exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "#tab-bar.demo{display:flex;flex-direction:column}#tab-bar .demoName{height:40px}#tab-bar .demo-preview-item .am-tab-bar{background-color:#fff}.ant-scroll-number.ant-badge-count.ant-badge-count-sm{font-size:12px !important}", ""]);

